import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  GuardResult,
  MaybeAsync,
  RouterStateSnapshot,
} from '@angular/router';
import { ProveedorFichaPage } from '../admin/_pages/proveedores/_pages/proveedor-ficha/proveedor-ficha.page';
import { MatDialog } from '@angular/material/dialog';
import { ModalFormularioEditadoComponent } from '../admin/shared/modals/modal-formulario-editado/modal-formulario-editado.component';
import { map } from 'rxjs';
import { UsuarioFichaPage } from '../admin/_pages/usuarios/_pages/usuario-ficha/usuario-ficha.page';
import { ClienteFichaPage } from '../admin/_pages/clientes/_pages/cliente-ficha/cliente-ficha.page';

@Injectable({
  providedIn: 'root',
})
export class FormularioConCambiosGuard
  implements
    CanDeactivate<ProveedorFichaPage | ClienteFichaPage | UsuarioFichaPage>
{
  private matDialog = inject(MatDialog);

  canDeactivate(
    component: ProveedorFichaPage | ClienteFichaPage | UsuarioFichaPage,
  ): MaybeAsync<GuardResult> {
    if (!component?.canDeactivate || component.canDeactivate()) {
      return true;
    }

    const dialogRef = this.matDialog.open(ModalFormularioEditadoComponent);

    return dialogRef.afterClosed().pipe(
      map((result) => {
        if (result) return true;
        else return false;
      }),
    );
  }
}
